/// <reference path="../_all.ts" />


//https://github.com/allenhwkim/angularjs-google-maps
//https://ngmap.github.io/#/!map_no_default_style.html

module partner {
  
  VendorAddressDirective.$inject = [
    '$window',
    'NgMap',
    '$timeout',
    'partnerService',
    'parallaxService',
    'pageMetaService',
  ];

  export function VendorAddressDirective(
    $window : ng.IWindowService,
    NgMap : angular.map.INgMap, 
    $timeout: ng.ITimeoutService,
    partnerService : PartnerService,
    parallaxService: navigation.IParallaxService,
    pageMetaService : navigation.IPageMetaService,): ng.IDirective {
    

    return {
      restrict: 'AE',
      scope: {
        vendor: '=', 
        linkedin: '@', 
        mapid: '@',
      },
      templateUrl: 'partner/VendorAddressDirective', 

      link: function (scope: IVendorAddressScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        scope.googleMapsUrl = "https://maps.googleapis.com/maps/api/js?key=AIzaSyAF1xLcjeFHOKAXWqhsv1x6cc7tIVtDlzU" //Api Key Managable from Google Cloud Console with admin@photometer.com
        scope.showMap = false;
        scope.progress = false;
        
        var geoCode = () => {
          scope.progress = true;
          
          $timeout(() => {
            partnerService.getPartnerLocation(scope.vendor).then((latlong) => {
              NgMap.getMap({ id: scope.mapid }).then(function (map) {                
                google.maps.event.trigger(map, 'resize'); 
                (<any>map).markers.addressmarker.setPosition(new google.maps.LatLng(latlong.lat,latlong.lng));
                map.panTo((<any>map).markers.addressmarker.getPosition());
                scope.progress = false;
              },
              function() { //no map?  NO MAP, YOU SAY? AHHHHHHHH…
                //console.log("map " + scope.mapid + " not found, try again in 300ms");
                $timeout(() => { geoCode(); }, 300);
              });
            });
          });
        }

        var showMap = (scrollTop :  number) => {
          if (element.offset().top <= 0) return; //wait for init
          if ((element.offset().top - $($window).height() - 400) > scrollTop) return;
          if (!scope.vendor) return;
          scope.progress = true;
          scope.showMap = true; 
          geoCode();
        }

        parallaxService.subscribeOnScroll(scope, (e: ng.IAngularEvent, scrollTop : number) =>  {
          if (!scope.vendor) return;
          if (!scope.showMap) {
            showMap(scrollTop);
          }
        });


        $(document).ready(function() {
          $timeout(() => { showMap($window.pageYOffset) }, 1000);
        });
        
        scope.$watch('vendor', function(newVal, oldVal) {
          if (newVal && !scope.showMap) showMap($window.pageYOffset);
          if (scope.showMap && newVal && newVal != oldVal) geoCode();
        })  
        
        scope.subjectQuery = function(template) {
          var page = pageMetaService.searchRouteParameter("ProductName");
          if (!page) page = pageMetaService.searchRouteParameter("MesuringTaskGroup");
          if (!page) page = pageMetaService.searchRouteParameter("Industry");
          if (page) {
            var title = page.DisplayName[pageMetaService.getPageMeta(navigation.HLFULL)];
            var subject = template.replace(/TITLE/g, title);
            return "?subject=" + encodeURI(subject);
          }
          return "";
        }

      }
    }
  }

}